import { SxProps, Theme } from "@mui/material/styles";

/** Merge multiple sx props into a single array */
export const mergeSx = (...styles: (SxProps<Theme> | undefined)[]) => {
  // Based on https://mui.com/system/getting-started/the-sx-prop/#passing-the-sx-prop
  return [...styles.filter(Boolean).map((style) => (Array.isArray(style) ? style : [style]))].flat();
};
